export default class Table {
	constructor() {
		const tables: NodeListOf<HTMLElement> = document.querySelectorAll('.wp-block-table');

		if (tables.length === 0) {
			return;
		}

		const observer: ResizeObserver = new ResizeObserver(this.onTableResize);
		tables.forEach((table) => {
			observer.observe(table);
		});
	}

	private onTableResize = (entries: ResizeObserverEntry[]) => {
		requestAnimationFrame(() => {
			entries.forEach((entry: ResizeObserverEntry) => {
				const target: HTMLElement = entry.target as HTMLElement;

				if (target.scrollWidth > target.clientWidth) {
					target.classList.add('scroll-enabled');
				} else {
					target.classList.remove('scroll-enabled');
				}
			});
		});
	};
}
